// Central content for Sterling Roofworks
export const LOGO = "https://customer-assets.emergentagent.com/job_640cb61b-cf18-4f4f-82ac-c2d721ad5d32/artifacts/m32ib2ao_ChatGPT%20Image%20Jul%206%2C%202026%2C%2009_11_54%20PM.png";

export const BUSINESS = {
  name: "Sterling Roofworks",
  legal: "Sterling Access Solutions Ltd",
  companyNo: "17186977",
  phone: "07475 378011",
  phoneHref: "tel:07475378011",
  whatsapp: "447475378011",
  email: "sterlingroofworks@gmail.com",
  address: ["51 Copperfield Road", "Poynton", "Cheshire", "SK12 1NQ"],
  tagline: "Built on Quality • Protecting What Matters",
};

export const WA_DEFAULT = "Hi Sterling Roofworks, I'd like to enquire about some roofing work at my property.";
export const waLink = (topic) =>
  `https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(topic ? `Hi Sterling Roofworks, I'd like to enquire about ${topic}.` : WA_DEFAULT)}`;

export const IMAGES = {
  hero: "/images/hero_uk_detached.webp",
  rooftops: "/images/interlude_rooftops.webp",
  before: "/images/before_tired_roof.webp",
  after: "/images/after_new_roof.webp",
};

export const STATS = [
  { value: 20, suffix: "+", label: "Years Experience" },
  { value: 500, suffix: "+", label: "Roofs Completed" },
  { value: 100, suffix: "%", label: "Customer Satisfaction" },
  { value: 10, suffix: "yr", label: "Workmanship Guarantee" },
];

export const SERVICES = [
  { slug: "new-roofs", title: "New Roofs", icon: "Home", blurb: "Complete new roof installations built to last a lifetime.", category: "New Roofs", img: "/images/svc_new_roofs.webp", wa: "a new roof" },
  { slug: "roof-replacements", title: "Roof Replacements", icon: "RefreshCw", blurb: "Full tear-off and premium replacement with modern materials.", category: "New Roofs", img: "/images/proj_tile_install.webp", wa: "a roof replacement" },
  { slug: "roof-repairs", title: "Roof Repairs", icon: "Wrench", blurb: "Fast, reliable repairs for leaks, slipped tiles and storm damage.", category: "Repairs", img: "/images/svc_roof_repairs_v2.webp", wa: "a roof repair" },
  { slug: "dry-ridge-systems", title: "Dry Ridge Systems", icon: "Layers", blurb: "Mechanically fixed, maintenance-free ridge solutions.", category: "Dry Ridge", img: "/images/svc_dry_ridge_real.webp", wa: "a dry ridge system" },
  { slug: "dry-verge-systems", title: "Dry Verge Systems", icon: "AlignJustify", blurb: "Weatherproof, mortar-free verge protection.", category: "Dry Ridge", img: "/images/svc_dry_verge.webp", wa: "a dry verge system" },
  { slug: "leadwork", title: "Leadwork", icon: "Shield", blurb: "Expert lead flashing and bespoke leadwork craftsmanship.", category: "Leadwork", img: "/images/svc_leadwork_v2.webp", wa: "leadwork" },
  { slug: "flat-roofing", title: "Flat Roofing", icon: "Square", blurb: "EPDM, GRP and felt systems with lasting waterproofing.", category: "Flat Roofs", img: "/images/svc_flat_roofing.webp", wa: "flat roofing" },
  { slug: "chimney-repairs", title: "Chimney Repairs", icon: "Factory", blurb: "Repointing, rebuilds and full chimney restoration.", category: "Repairs", img: "/images/svc_chimney.webp", wa: "chimney repairs" },
  { slug: "fascias-soffits", title: "Fascias & Soffits", icon: "PanelTop", blurb: "uPVC fascias, soffits and guttering that transform a home.", category: "Repairs", img: "/images/svc_fascias.webp", wa: "fascias and soffits" },
  { slug: "guttering", title: "Guttering", icon: "Droplets", blurb: "Seamless guttering supply, repair and cleaning.", category: "Repairs", img: "/images/proj_grp_garage.webp", wa: "guttering" },
  { slug: "emergency-roofing", title: "Emergency Roofing", icon: "Siren", blurb: "24/7 rapid response for urgent roofing emergencies.", category: "Repairs", img: "/images/proj_scaffold_semi.webp", wa: "an emergency roof repair" },
  { slug: "roof-inspections", title: "Roof Inspections", icon: "Search", blurb: "Detailed inspections and honest condition reports.", category: "New Roofs", img: "/images/before_tired_roof.webp", wa: "a roof inspection" },
];

export const WHY = [
  "Fully Insured", "Highly Experienced", "Premium Materials", "Workmanship Guarantee",
  "Clean & Tidy", "Honest Pricing", "Family Business", "Excellent Reviews",
  "Fully Qualified", "Local Company", "No Hidden Costs", "Free Advice",
];

export const PROCESS = [
  { no: "01", title: "Free Roof Survey", text: "We visit your property, assess the roof and discuss your needs in full." },
  { no: "02", title: "Detailed Fixed Quotation", text: "A transparent, itemised quote with no hidden costs — ever." },
  { no: "03", title: "Professional Installation", text: "Our qualified team delivers meticulous, clean and safe workmanship." },
  { no: "04", title: "Final Inspection & Guarantee", text: "We inspect together and register your 10-year workmanship guarantee." },
];

export const REVIEWS = [
  { name: "James Holland", area: "Stockport", platform: "Google", text: "Sterling replaced our entire roof and the finish is flawless. Professional, tidy and genuinely lovely to deal with." },
  { name: "Sarah Whitfield", area: "Poynton", platform: "Trustpilot", text: "From quote to completion everything was seamless. The dry ridge system looks fantastic and the price was fair." },
  { name: "David Ashworth", area: "Wilmslow", platform: "Facebook", text: "Emergency repair after a storm — they came the same day. Cannot recommend Sterling Roofworks highly enough." },
  { name: "Emma Clarke", area: "Marple", platform: "Google", text: "Beautiful leadwork around our chimney. True craftsmen who take pride in every detail. 5 stars." },
  { name: "Michael Boyd", area: "Cheadle", platform: "Trustpilot", text: "Honest pricing, no upselling, brilliant communication. Our new flat roof is perfect." },
];

export const AREAS = [
  "Manchester", "Stockport", "Poynton", "Marple", "Romiley", "Hyde",
  "Glossop", "Macclesfield", "Wilmslow", "Cheadle", "Hazel Grove", "Cheshire",
];

export const FAQS = [
  { q: "How much does a new roof cost?", a: "Every roof is different, so we provide a free survey and a detailed fixed quotation. Most residential new roofs in our area range from £4,000 to £12,000 depending on size, materials and access." },
  { q: "How long does roofing work take?", a: "A typical roof replacement takes 3–7 days. Repairs are often completed same day, while larger projects are scheduled around the best weather windows." },
  { q: "Do you provide guarantees?", a: "Yes. All our workmanship is covered by a 10-year guarantee, and we only fit premium materials that carry their own manufacturer warranties." },
  { q: "Do you offer emergency roofing?", a: "Absolutely. We offer a 24/7 emergency response for leaks and storm damage across Greater Manchester and Cheshire." },
  { q: "Are quotations free?", a: "Always. Every survey and quotation is completely free and no-obligation." },
];

export const PROJECTS = [
  {
    id: "full-roof-replacement",
    type: "Full Roof Replacement",
    cat: "New Roofs",
    location: "Stockport, Greater Manchester",
    cover: "/images/after_new_roof.webp",
    work: ["Complete strip of the original tiled roof", "New breathable membrane & treated battens", "Premium dark grey interlocking tiles", "Mechanically fixed dry ridge system", "New uPVC fascias, soffits & guttering"],
    photos: [
      { img: "/images/before_tired_roof.webp", stage: "Before" },
      { img: "/images/proj_felt_batten.webp", stage: "During" },
      { img: "/images/proj_tile_install.webp", stage: "During" },
      { img: "/images/after_new_roof.webp", stage: "After" },
    ],
  },
  {
    id: "natural-slate-reroof",
    type: "Natural Slate Reroof",
    cat: "New Roofs",
    location: "Cheshire",
    cover: "/images/proj_victorian_detached.webp",
    work: ["Full strip & re-slate in natural slate", "Traditional copper nail fixing", "Chimney repointed with new lead flashings", "Ornate ridge detail retained"],
    photos: [
      { img: "/images/proj_slate_install.webp", stage: "During" },
      { img: "/images/svc_leadwork_v2.webp", stage: "Detail" },
      { img: "/images/proj_victorian_detached.webp", stage: "After" },
    ],
  },
  {
    id: "hip-roof-dry-ridge",
    type: "Hip Roof & Dry Ridge System",
    cat: "Dry Ridge",
    location: "Greater Manchester",
    cover: "/images/proj_bungalow_hip.webp",
    work: ["New hipped roof in clay-tone concrete tiles", "Mechanically fixed dry ridge & hip system", "Dry verge to all gable edges", "Chimney flaunching renewed"],
    photos: [
      { img: "/images/proj_bungalow_hip.webp", stage: "After" },
      { img: "/images/svc_dry_ridge.webp", stage: "Detail" },
      { img: "/images/svc_dry_verge.webp", stage: "Detail" },
    ],
  },
  {
    id: "flat-roof-extension",
    type: "Flat Roofing — EPDM & GRP",
    cat: "Flat Roofs",
    location: "Stockport",
    cover: "/images/svc_flat_roofing.webp",
    work: ["EPDM rubber system to rear extension", "GRP fibreglass finish to garage roof", "New insulation & edge trims", "20-year membrane guarantee"],
    photos: [
      { img: "/images/svc_flat_roofing.webp", stage: "After" },
      { img: "/images/proj_grp_garage.webp", stage: "After" },
    ],
  },
  {
    id: "chimney-leadwork",
    type: "Chimney & Leadwork Restoration",
    cat: "Leadwork",
    location: "Greater Manchester",
    cover: "/images/svc_chimney.webp",
    work: ["Chimney stack repointed", "New clay pots & cement flaunching", "Code 4 stepped lead flashings", "Lead soakers dressed to slate"],
    photos: [
      { img: "/images/svc_chimney.webp", stage: "After" },
      { img: "/images/svc_leadwork_v2.webp", stage: "Detail" },
    ],
  },
  {
    id: "roof-windows-repair",
    type: "Roof Windows & Repairs",
    cat: "Repairs",
    location: "Cheshire",
    cover: "/images/proj_velux.webp",
    work: ["Two roof windows fitted to slate pitch", "Flashing kits dressed & weathered", "Slipped tiles & storm damage repaired", "Scaffold access throughout"],
    photos: [
      { img: "/images/proj_scaffold_semi.webp", stage: "During" },
      { img: "/images/proj_velux.webp", stage: "After" },
    ],
  },
];

export const PROJECT_FILTERS = ["All", "New Roofs", "Repairs", "Dry Ridge", "Flat Roofs", "Leadwork"];

export const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Our Work", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Areas We Cover", href: "#areas" },
  { label: "Contact", href: "#contact" },
];
